"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActionsColumn = exports.actionsColumn = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Context_1 = require("./Context");
require("./index.scss");
const actionsClassName = 'actions-column';
const getColumnModifier = (columnsNumber) => {
    if (columnsNumber === 2)
        return `${actionsClassName}--two-column-icons`;
    if (columnsNumber === 3)
        return `${actionsClassName}--three-column-icons`;
    return `${actionsClassName}--four-column-icons`;
};
const actionsColumn = (options) => {
    const { Header, columnsNumber, rowsNumber, layouts, config, order } = options;
    const filteredOrder = order.filter(key => !config[key].notAllowed);
    return {
        Header: Header !== null && Header !== void 0 ? Header : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Table/Column:Actions', defaultMessage: 'Actions' })),
        id: 'actions',
        headerClasses: ['table__cell--without-opacity', getColumnModifier(columnsNumber)],
        cellClasses: ['table__cell--without-opacity'],
        Cell: (props) => {
            const data = props.row.original;
            const layoutsRenders = filteredOrder.map(key => layouts[key].items.map((item, i) => {
                const { click, getState, isLoading, disabled, hidden } = config[key];
                const state = getState === null || getState === void 0 ? void 0 : getState(data);
                return (kind) => item.render({
                    key: `${String(key)}_${i}`,
                    kind,
                    click: (option) => click(data, option, props.tableRef.current),
                    isLoading: (option) => !!isLoading && isLoading(data, option),
                    disabled: (option) => !!disabled && disabled(data, option),
                    hidden: (option) => !!hidden && hidden(data, option),
                    state,
                });
            }));
            const renders = layoutsRenders.flat();
            const renderActions = () => {
                const iconsNumber = columnsNumber * rowsNumber;
                if (renders.length <= iconsNumber) {
                    return [
                        renders.map(render => render('icon')),
                        [],
                    ];
                }
                return [
                    renders.slice(0, iconsNumber - 1).map(render => render('icon')),
                    renders.slice(iconsNumber - 1).map(render => render('full')),
                ];
            };
            const [actionElements, restActionElements] = renderActions();
            const { rowIndex, rowCount } = props;
            return (react_1.default.createElement("span", { className: actionsClassName },
                actionElements,
                react_1.default.createElement(Context_1.ActionContextMenu, { openOnHover: true, showUp: (rowCount - rowIndex < 3) && rowIndex > 1, actions: restActionElements })));
        },
        hidden: config.notAllowed || filteredOrder.length === 0,
    };
};
exports.actionsColumn = actionsColumn;
const createActionsColumn = (options) => (config) => (0, exports.actionsColumn)({ ...options, config });
exports.createActionsColumn = createActionsColumn;
//# sourceMappingURL=index.js.map